enum FormFields {
  Building_Types = "buildingTypes",
  Transaction_Type = "transactionType",
  Stories = "stories",
  Project_Status = "projectStatus",
  Year_Built = "yearBuilt",
  Number_Of_Towers = "numberOfTowers",
  Number_Of_Units = "numberOfUnits",
  Construction_Start_Date = "constructionStartDate",
  Completion_Date = "completionDate",
  Lead_Architect = "leadArchitect",
  Landscape_Architect = "landscapeArchitect",
  Local_Architect = "localArchitect",
  Interior_Designer = "interiorDesigner",
  Overview = "overview",
  Project_Details = "projectDetails",
  Broker_Commission = "brokerCommission",
  Tax_Information = "taxInformation",
  Working_Hours = "workingHours",
  Sales_Gallery_Status = "salesGalleryStatus",
  Sales_Gallery_Address = "salesGalleryAddress",
  Sales_Gallery_Hours = "salesGalleryHours",
  Virtual_Tour_Links = "virtualTourLinks",
}

const FormFieldsList = [
  FormFields.Overview,
  FormFields.Project_Details,
  FormFields.Broker_Commission,
  FormFields.Lead_Architect,
  FormFields.Landscape_Architect,
  FormFields.Local_Architect,
  FormFields.Interior_Designer,
  FormFields.Building_Types,
  FormFields.Transaction_Type,
  FormFields.Stories,
  FormFields.Project_Status,
  FormFields.Year_Built,
  FormFields.Number_Of_Towers,
  FormFields.Number_Of_Units,
  FormFields.Construction_Start_Date,
  FormFields.Completion_Date,
  FormFields.Tax_Information,
  FormFields.Sales_Gallery_Status,
  FormFields.Sales_Gallery_Address,
  FormFields.Sales_Gallery_Hours,
  FormFields.Virtual_Tour_Links,
];

export { FormFields, FormFieldsList };
